import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleGetOrgPermissionPermission } from 'store/organizations/thunks';
import { handleGetStudentGroup } from 'store/studentGroup/thunks';
import { useCurrentUser } from 'store/users/selectors';
import { handleCountPreview, handleListWorkSheet } from 'store/worksheet/thunks';
import useBadWords from '../words/badWords';
import { useCurrentClass } from 'store/classes/selectors';
import { handleListStoryStandard } from 'store/story/thunks';

const useFetchWrapper = () => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const currentOrg = useCurrentOrg();
  const { fetchBadWords, loadWordsWithSynonyms } = useBadWords();
  
  
  const currentClass = useCurrentClass();

  const fetchContent = () => {
    Promise.allSettled([
      dispatch(handleGetStudentGroup(currentUser?.id)),
      dispatch(handleListWorkSheet('', currentUser?.role, get(currentUser, 'id'), null, null, null, null, currentClass?.id)),
      dispatch(handleCountPreview()),
      dispatch(handleGetOrgPermissionPermission(currentOrg?.parentId)),
      fetchBadWords(),
      loadWordsWithSynonyms(),
      dispatch(handleListStoryStandard(currentUser?.id,currentUser?.role,currentOrg?.id))
    ]);
  };
  return { fetchContent };
};

export default useFetchWrapper;
